export const ENVIRONMENT = {
  EXTREME_HEAT: 'Extreme Heat (above 80 °C)',
  EXTREME_COLD: 'Extreme Cold (below -20 °C)',
  CHEMICAL_WASHDOWN: 'Chemical Washdown',
  INSTALLED_OUTDOORS: 'Installed Outdoors',
  WATER_WASHDOWN: 'Water Washdown',
  DUST: 'Dust',
  AIRBORNE_DEBRIS: 'Airborne Debris',
  HIGH_TRAFFIC: 'High-Traffic Area',
  OTHER: 'Other',
} as const;

export type TEnvironment = (typeof ENVIRONMENT)[keyof typeof ENVIRONMENT];

export const environments: { label: string; value: TEnvironment }[] = [
  { label: 'Extreme Heat (above 80 °C)', value: ENVIRONMENT.EXTREME_HEAT },
  { label: 'Extreme Cold (below -20 °C)', value: ENVIRONMENT.EXTREME_COLD },
  { label: 'Chemical Washdown', value: ENVIRONMENT.CHEMICAL_WASHDOWN },
  { label: 'Installed Outdoors', value: ENVIRONMENT.INSTALLED_OUTDOORS },
  { label: 'Water Washdown', value: ENVIRONMENT.WATER_WASHDOWN },
  { label: 'Dust', value: ENVIRONMENT.DUST },
  { label: 'Airborne Debris', value: ENVIRONMENT.AIRBORNE_DEBRIS },
  { label: 'High-Traffic Area', value: ENVIRONMENT.HIGH_TRAFFIC },
  { label: 'Other', value: ENVIRONMENT.OTHER },
];
